import { Container } from '@akyga/shared-ui/Container';

export default Container;
